// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_control_v1_verifiable_type.ml",
      66,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifiableType"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Ident"
        ]]
    });

const Ident = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_control_v1_verifiable_type.ml",
      97,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifiableType"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_control_v1_verifiable_type.ml",
      126,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifiableType"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_control_v1_verifiable_type.ml",
      153,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifiableType"
        ]]
    });

const VerifiableType = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_control_v1_verifiable_type.ml",
      178,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.ident.control.v1.VerifiableType";
}

function to_int(param) {
  switch (param) {
    case /* VERIFIABLE_TYPE_UNSPECIFIED */0 :
        return 0;
    case /* VERIFIABLE_TYPE_ID_CARD_SCAN */1 :
        return 10;
    case /* VERIFIABLE_TYPE_LIVENESS */2 :
        return 20;
    case /* VERIFIABLE_TYPE_FACE_MATCH */3 :
        return 30;
    case /* VERIFIABLE_TYPE_COID */4 :
        return 40;
    case /* VERIFIABLE_TYPE_EGOV_DOC */5 :
        return 50;
    
  }
}

function from_int_exn(n) {
  if (n >= 21) {
    if (n !== 30) {
      if (n !== 40) {
        if (n !== 50) {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        } else {
          return /* VERIFIABLE_TYPE_EGOV_DOC */5;
        }
      } else {
        return /* VERIFIABLE_TYPE_COID */4;
      }
    } else {
      return /* VERIFIABLE_TYPE_FACE_MATCH */3;
    }
  } else if (n !== 0) {
    if (n !== 10) {
      if (n >= 20) {
        return /* VERIFIABLE_TYPE_LIVENESS */2;
      } else {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      }
    } else {
      return /* VERIFIABLE_TYPE_ID_CARD_SCAN */1;
    }
  } else {
    return /* VERIFIABLE_TYPE_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* VERIFIABLE_TYPE_UNSPECIFIED */0 :
        return "VERIFIABLE_TYPE_UNSPECIFIED";
    case /* VERIFIABLE_TYPE_ID_CARD_SCAN */1 :
        return "VERIFIABLE_TYPE_ID_CARD_SCAN";
    case /* VERIFIABLE_TYPE_LIVENESS */2 :
        return "VERIFIABLE_TYPE_LIVENESS";
    case /* VERIFIABLE_TYPE_FACE_MATCH */3 :
        return "VERIFIABLE_TYPE_FACE_MATCH";
    case /* VERIFIABLE_TYPE_COID */4 :
        return "VERIFIABLE_TYPE_COID";
    case /* VERIFIABLE_TYPE_EGOV_DOC */5 :
        return "VERIFIABLE_TYPE_EGOV_DOC";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "VERIFIABLE_TYPE_COID" :
        return /* VERIFIABLE_TYPE_COID */4;
    case "VERIFIABLE_TYPE_EGOV_DOC" :
        return /* VERIFIABLE_TYPE_EGOV_DOC */5;
    case "VERIFIABLE_TYPE_FACE_MATCH" :
        return /* VERIFIABLE_TYPE_FACE_MATCH */3;
    case "VERIFIABLE_TYPE_ID_CARD_SCAN" :
        return /* VERIFIABLE_TYPE_ID_CARD_SCAN */1;
    case "VERIFIABLE_TYPE_LIVENESS" :
        return /* VERIFIABLE_TYPE_LIVENESS */2;
    case "VERIFIABLE_TYPE_UNSPECIFIED" :
        return /* VERIFIABLE_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, VerifiableType, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifiableType"
        ]]
    }, V1, {
      VerifiableType: VerifiableType
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifiableType"
              ]]
          },
          "V1"
        ]]
    }, Control, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifiableType"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    }, Ident, {
      Control: Control
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifiableType"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Ident"
        ]]
    }, Buhta, {
      Ident: Ident
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
